import { render, staticRenderFns } from "./form.vue?vue&type=template&id=4ca0d41a&scoped=true&"
import script from "./form.vue?vue&type=script&lang=js&"
export * from "./form.vue?vue&type=script&lang=js&"
import style0 from "./form.vue?vue&type=style&index=0&lang=stylus&"
import style1 from "./form.vue?vue&type=style&index=1&id=4ca0d41a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca0d41a",
  null
  
)

export default component.exports